import * as client_hooks from '../../../../src/hooks.client.ts';
import * as universal_hooks from '../../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89')
];

export const server_loads = [];

export const dictionary = {
		"/": [21],
		"/auth/accept-invitation": [~82],
		"/auth/email-conflict": [83],
		"/auth/error": [84],
		"/auth/session-expired": [85],
		"/(authenticated)/dashboard": [22,[2,3]],
		"/(authenticated)/dashboard/conference-request": [70,[2,3]],
		"/(authenticated)/dashboard/create": [71,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]": [23,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/calendar": [24,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/check-in": [25,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/committee-assignment": [26,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/connect-supervisor": [27,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/info": [28,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/paperhub": [29,[2,3,4]],
		"/(authenticated)/dashboard/[conferenceId]/paperhub/newPaper": [31,[2,3,4]],
		"/(authenticated)/dashboard/[conferenceId]/paperhub/newResolution": [32,[2,3,4]],
		"/(authenticated)/dashboard/[conferenceId]/paperhub/snippets": [33,[2,3,4]],
		"/(authenticated)/dashboard/[conferenceId]/paperhub/view/[paperId]": [34,[2,3,4]],
		"/(authenticated)/dashboard/[conferenceId]/paperhub/[paperId]": [30,[2,3,4]],
		"/(authenticated)/dashboard/[conferenceId]/payment": [35,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/postal-registration": [36,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/registration-mode": [37,[2,5]],
		"/(authenticated)/dashboard/[conferenceId]/seats": [38,[2,3]],
		"/(authenticated)/dashboard/[conferenceId]/team/announcement": [39,[2,6,7]],
		"/(authenticated)/dashboard/[conferenceId]/team/assignment/delegations": [40,[2,6,8]],
		"/(authenticated)/dashboard/[conferenceId]/team/assignment/finish": [41,[2,6,8]],
		"/(authenticated)/dashboard/[conferenceId]/team/assignment/introduction": [42,[2,6,8]],
		"/(authenticated)/dashboard/[conferenceId]/team/assignment/sighting": [43,[2,6,8]],
		"/(authenticated)/dashboard/[conferenceId]/team/assignment/singles": [44,[2,6,8]],
		"/(authenticated)/dashboard/[conferenceId]/team/assignment/weighting": [45,[2,6,8]],
		"/(authenticated)/dashboard/[conferenceId]/team/attendance": [46,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/calendar": [47,[2,6,9]],
		"/(authenticated)/dashboard/[conferenceId]/team/check-in": [48,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/cleanup": [49,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/configuration": [50,[2,6,10]],
		"/(authenticated)/dashboard/[conferenceId]/team/configuration/committees": [51,[2,6,10]],
		"/(authenticated)/dashboard/[conferenceId]/team/downloads": [52,[2,6,11]],
		"/(authenticated)/dashboard/[conferenceId]/team/helper": [53,[2,6,12]],
		"/(authenticated)/dashboard/[conferenceId]/team/import": [54,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/invitations": [55,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/members": [56,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/participants": [57,[2,6,13]],
		"/(authenticated)/dashboard/[conferenceId]/team/payments": [58,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/plausibility": [59,[2,6,14]],
		"/(authenticated)/dashboard/[conferenceId]/team/postal-registration": [60,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/schools": [61,[2,6,15]],
		"/(authenticated)/dashboard/[conferenceId]/team/schools/[schoolId]": [62,[2,6,15]],
		"/(authenticated)/dashboard/[conferenceId]/team/seat-planning": [63,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/seats": [64,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/stats": [65,[2,6,16]],
		"/(authenticated)/dashboard/[conferenceId]/team/survey": [66,[2,6,17]],
		"/(authenticated)/dashboard/[conferenceId]/team/survey/[surveyId]": [67,[2,6,17]],
		"/(authenticated)/dashboard/[conferenceId]/team/user/[userId]": [68,[2,6]],
		"/(authenticated)/dashboard/[conferenceId]/team/waiting-list": [69,[2,6]],
		"/(authenticated)/my-account": [72,[2,18]],
		"/(authenticated)/registration": [73,[2,19]],
		"/(authenticated)/registration/[conferenceId]": [74,[2,19,20]],
		"/(authenticated)/registration/[conferenceId]/create-delegation": [75,[2,19,20]],
		"/(authenticated)/registration/[conferenceId]/individual": [76,[2,19,20]],
		"/(authenticated)/registration/[conferenceId]/individual/[roleId]": [77,[2,19,20]],
		"/(authenticated)/registration/[conferenceId]/join-delegation": [78,[2,19,20]],
		"/(authenticated)/registration/[conferenceId]/supervisor": [79,[2,19,20]],
		"/(authenticated)/registration/[conferenceId]/waiting-list": [80,[2,19,20]],
		"/(authenticated)/team-tender": [81,[2]],
		"/tt": [86],
		"/unsubscribe": [87],
		"/validateCertificate/[jwt]": [88],
		"/vc/[jwt]": [89]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);